import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import HttpClientService from "./common/api/http-client.provider";
import { useCallback } from "react";
import config from "./config";
import { Outlet, useNavigate } from "react-router-dom";
import AppRoutes from "./pages/app.routing";
import { Helmet } from 'react-helmet-async';

function App() {
    const oktaAuth = new OktaAuth(config.oidc);
    const navigate = useNavigate();

    const restoreOriginalUri = useCallback((oktaAuth: OktaAuth, originalUri: string) => {
        navigate(toRelativeUrl(originalUri || "/", window.location.origin), {
            replace: true,
        });
    }, []);

    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=2.0" />
            </Helmet>
            <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
                <HttpClientService>
                    <AppRoutes />
                    <Outlet />
                </HttpClientService>
            </Security>
        </>
    );
}

export default App;
